export const PICTURE_PASSWORD_ASSIGNED_MODAL_PENDING = 'PICTURE_PASSWORD_ASSIGNED_MODAL_PENDING';

export const PicturePasswordIconStyle = {
  COLORFUL: 'colorful',
  STANDARD: 'standard',
};

export const OptionsForSignIn = {
  USERNAME_PASSWORD: 'username_password',
  USERNAME_ONLY: 'username_only',
  PICTURE_PASSWORD: 'picture_password',
};
